
export interface Address {
    houseNo: string;
    street: string;
    city: string;
    county: string;
    country: string;
    postcode: string;
}


export function getDefaultAddress(): Address {
    return {
        houseNo: '',
        street: '',
        city: '',
        county: '',
        country: '',
        postcode: ''
    };
}